import { Component, Injector } from '@angular/core';
import type { OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';

import { ViewBasePage } from '@shared/pages';
import { RoutesService, ShuttlesService } from '@shared/services';
import type { TShuttle } from '@shared/models';

@Component({
    'selector': 'app-routes',
    'templateUrl': './routes.page.html',
    'styleUrls': ['./routes.page.scss'],
    'standalone': true,
    'imports': [ CommonModule, FormsModule, IonicModule ]
})
export class RoutesPage extends ViewBasePage implements OnInit, OnDestroy {
    private shuttlesSubscription: any;
    public idleShuttles: any = [];
    public assignedShuttles: any = [];
    public travelingShuttles: any = [];

    constructor(private routesService: RoutesService, private shuttlesService: ShuttlesService,
        injector: Injector) {
        super(injector);
    }

    public ionViewWillEnter(): void {
        super.setCurrentView(this.Constants.VIEW_ROUTES);
    }

    public override async ngOnInit(): Promise<void> {
        super.ngOnInit();

        await this.uxHelperService.showSpinner();

        const shuttlesObservable = this.shuttlesService.getObservable();
        this.shuttlesSubscription = await shuttlesObservable.subscribe((shuttles: TShuttle[]) => {
            const allShuttles = this.shuttlesService.sort(shuttles);

            this.idleShuttles = allShuttles.filter((shuttle: TShuttle) => (shuttle.status === 'Idle'));
            this.idleShuttles = this.shuttlesService.sort(this.idleShuttles);

            this.assignedShuttles = allShuttles.filter((shuttle: TShuttle) => (shuttle.status === 'Assigned'));
            this.assignedShuttles = this.shuttlesService.sort(this.assignedShuttles);

            this.travelingShuttles = allShuttles.filter((shuttle: TShuttle) => (shuttle.status === 'Traveling'));
            this.travelingShuttles = this.shuttlesService.sort(this.travelingShuttles);
        });

        this.initMoreMenu();
        await this.uxHelperService.hideSpinner();
    }

    public override ngOnDestroy(): void {
        super.ngOnDestroy();
        // this.ticketsSubscription.unsubscribe();
        if (this.shuttlesSubscription) {
            this.shuttlesSubscription.unsubscribe();
            this.shuttlesSubscription = null;
        }
    }

    public initMoreMenu(): void {
        this.pushPopoverMenuItem('Show Tour', 'show-routes-tour');
    }

    public async onOpenRouteClick(shuttle) {
        // The route uid is the same as the shuttle uid - see RoutePage6.saveRoute().
        const route = await this.routesService.getByUid(shuttle.uid);

        if (route) {
            super.setViewModel({ 'uid': shuttle.uid, 'route': route });
            this.router.navigateByUrl('/routes/routeView');

            // this.router.navigateByUrl('/routeView');
        }
    }

    public onAddClick(): void {
        this.router.navigateByUrl('/routes/route1ShuttleSelection');
    }
}
